import { companyTypePermissionPrefix } from 'src/constants/company/company-type-permission-prefix';
import { COMPANY_TYPE_ROUTE } from 'src/pages/Company/Add/enums/company-type-route';

export const checkCompanyType = (permission: string, companyType: COMPANY_TYPE_ROUTE) => {
    return companyTypePermissionPrefix[companyType] + permission;
};
